import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import ContractRequisitionGroupComponent from './Elements/ContractRequisitionGroupComponent';

import { Link, Redirect} from 'react-router-dom';

import InputMask from 'react-input-mask';
import Toggle from 'react-toggle';
import Select from 'react-select';

import { Tabs, Tab } from 'react-bootstrap';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class RolesEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      key: 1,
      id: '',
      name: '',
      base: 0,
      master: 0,
      cvo: 0,
      crew: 0,
      crew_type: null,
      mechanic: 0,
      management: 0,
      aso: 0,
      roles_list: [],
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.loadData = this.loadData.bind(this);
    this.edit = this.edit.bind(this);
    this.addSimilar = this.addSimilar.bind(this);
    this.deleteSimilar = this.deleteSimilar.bind(this);
    this.updateRoleSimilars = this.updateRoleSimilars.bind(this);
  }
  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  }
  handleToggleTypeChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change['master'] = 0;
    change['cvo'] = 0;
    change['crew'] = 0;
    change['mechanic'] = 0;
    change['management'] = 0;
    change[name] = value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  updateRoleSimilars() {
    var confirm = window.confirm(this.locale.Cargos.EditarCargo.atualizarSimilar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        var url = config.get('api') + '/cargo/atualizar/similares/'+self.props.match.params.id;
        fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        });
      });
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/cargo/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/cargos');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.main.id,
            name: responseJson.data.main.name,
            base: responseJson.data.main.base,
            master: responseJson.data.main.master,
            cvo: responseJson.data.main.cvo,
            crew: responseJson.data.main.crew,
            crew_type: responseJson.data.main.crew_type,
            mechanic: responseJson.data.main.mechanic,
            management: responseJson.data.main.management,
            aso: responseJson.data.main.aso,
            similars: responseJson.data.similars,
            roles_list: responseJson.data.roles_list,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      });/* Overlay */
    });
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      base: this.state.base,
      master: this.state.master,
      crew: this.state.crew,
      crew_type: this.state.crew_type,
      cvo: this.state.cvo,
      mechanic: this.state.mechanic,
      management: this.state.management,
      aso: this.state.aso,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/cargo', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  // Salva role similar
  addSimilar(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      role_id: this.state.id,
      similar_id: this.state.similar_id,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/cargo/similar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
        if (responseJson.status === 'success') {
          self.setState({similars: responseJson.data});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  deleteSimilar (role_similar_id) {
    var confirm = window.confirm(this.locale.Cargos.EditarCargo.deletarSimilar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/cargo/similar/' + role_similar_id + '/' + self.state.id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({similars: responseJson.data});
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }


  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Cargos.EditarCargo.titulo}</h3>
      <div className="btn-group pull-right">
        <Link to="/cargos" className="btn btn-default"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      </div>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Cargos.EditarCargo.tabDados.formulario.Nome}:</label>
              <input type="text" name="name" className="form-control" placeholder={this.locale.Cargos.EditarCargo.tabDados.formulario.placeholder.Registro} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Cargos.EditarCargo.tabDados.formulario.Funcao}:</label>
              <Select
                className="form-field-name"
                name="crew_type"
                value={this.state.crew_type}
                searchable={true}
                placeholder={this.locale.Cargos.EditarCargo.tabDados.formulario.placeholder.SelectionarTipoFuncao}
                onChange={this.handleSelectChange.bind(this, 'crew_type')}
                options={[
                  {value: 'Captain', label: this.locale.Cargos.EditarCargo.tabDados.formulario.opcoesFuncao.Comandante},
                  {value: 'Copilot', label: this.locale.Cargos.EditarCargo.tabDados.formulario.opcoesFuncao.Copiloto},
                  {value: 'Atendant', label: this.locale.Cargos.EditarCargo.tabDados.formulario.opcoesFuncao.Comissario},
                ]}
              />
            </div>
          </div>
          <div className="col-md-4">
            <div className="form-group">
              <label>{this.locale.Cargos.EditarCargo.tabDados.formulario.ObrigatorioASO}?</label>
              <br/>
              <Toggle
                checked={this.state.aso}
                aria-label='No label tag'
                name="aso"
                onChange={this.handleToggleChange.bind(this, 'aso')} />
            </div>
          </div>
        </div>
        <hr/>
        <h4>{this.locale.Cargos.EditarCargo.tabDados.formulario.tituloTiposDeCargo}</h4>
        <hr/>
        <div className="row">
          <div className="col-md-2">
            <div className="form-group">
              <label>{this.locale.Cargos.EditarCargo.tabDados.formulario.Tripulantes}</label>
              <br/>
              <Toggle
                checked={this.state.crew}
                aria-label='No label tag'
                name="crew"
                onChange={this.handleToggleTypeChange.bind(this, 'crew')} />
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label>{this.locale.Cargos.EditarCargo.tabDados.formulario.CVODVO}</label>
              <br/>
              <Toggle
                checked={this.state.cvo}
                aria-label='No label tag'
                name="cvo"
                onChange={this.handleToggleTypeChange.bind(this, 'cvo')} />
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label>{this.locale.Cargos.EditarCargo.tabDados.formulario.MestreDeCarga}</label>
              <br/>
              <Toggle
                checked={this.state.master}
                aria-label='No label tag'
                name="master"
                onChange={this.handleToggleTypeChange.bind(this, 'master')} />
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label>{this.locale.Cargos.EditarCargo.tabDados.formulario.Mecanico}</label>
              <br/>
              <Toggle
                checked={this.state.mechanic}
                aria-label='No label tag'
                name="mechanic"
                onChange={this.handleToggleTypeChange.bind(this, 'mechanic')} />
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-group">
              <label>{this.locale.Cargos.EditarCargo.tabDados.formulario.Administrativo}</label>
              <br/>
              <Toggle
                checked={this.state.management}
                aria-label='No label tag'
                name="management"
                onChange={this.handleToggleTypeChange.bind(this, 'management')} />
            </div>
          </div>
        </div>
        <hr/>
        <div>
          <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.Cargos.EditarCargo.tabDados.formulario.botaoSalvarEdicao}</button>
        </div>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default RolesEdit;



// WEBPACK FOOTER //
// ./src/Components/Roles/RolesEdit.js